import * as React from 'react';

import { CompoundUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';

import CompoundPreview from '../Shared/CompoundTextPreview';
import Preview from '../Shared/TextPreview';

type Props = React.ComponentProps<typeof Preview> | React.ComponentProps<typeof CompoundPreview>;

const CalculatedField: React.FC<Props> = (props) => {
	const { unit } = props;

	if (unit && CompoundUnitEnum[unit]) {
		return (
			<CompoundPreview {...(props as React.ComponentProps<typeof CompoundPreview>)} />
		);
	}
	return (
		<div className="report-block__calculated-field">
			<Preview {...(props as React.ComponentProps<typeof Preview>)} />
		</div>
	);
};

export default React.memo(CalculatedField);
